import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setUsers = users => {
	return {
		type: ActionTypes.LOAD_USERS,
		users: users.data
	};
};

export const loadUsers = token => {
	return dispatch => {

		axios
			.get("https://getupstudio.co/solanasapi/usuario/")
			.then(response => {
				if (response != undefined) dispatch(setUsers(response.data));
			})
			.catch(error => {});
	};
};
